import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import LoginFlow from 'components/pages/login/LoginFlow'

import { fetchAppData } from '../App/actions'
import { selectIsDataLoaded, selectPartner } from '../App/selectors'
import { addToast } from '../Toasts/actions'

import actions from './actions'
import {
  selectEulaHTML,
  selectLoginError,
  selectLoginLoader,
  selectLoginStep,
  selectLoginSubmitLoader,
  selectSSOUrl,
  selectTFAParingUrl,
  selectTimeTillUnblock,
} from './selectors'

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...actions,
      fetchAppData,
      addToast,
    },
    dispatch
  )

const mapStateToProps = (state) => ({
  error: selectLoginError(state),
  loginStep: selectLoginStep(state),
  loginLoader: selectLoginLoader(state),
  loginSubmitLoader: selectLoginSubmitLoader(state),
  timeTillUnlock: selectTimeTillUnblock(state),
  tfaParingUrl: selectTFAParingUrl(state),
  ssoUrl: selectSSOUrl(state),
  partner: selectPartner(state),
  isAppDataLoaded: selectIsDataLoaded(state),
})

const render = connect(mapStateToProps, mapDispatchToProps)(LoginFlow)

export default render
